import { useSyncExternalStore } from "react";
let activeTarget = null;
const listeners = new Set();
function subscribe(listener) {
    listeners.add(listener);
    return ()=>{
        listeners.delete(listener);
    };
}
export function setContextMenuActiveTarget(target) {
    if (activeTarget === target) return;
    activeTarget = target;
    for (const listener of listeners)listener();
}
export function useContextMenuActiveTarget() {
    return useSyncExternalStore(subscribe, ()=>activeTarget, ()=>null);
}
export function useIsContextMenuActiveNode(nodeId) {
    return useSyncExternalStore(subscribe, ()=>nodeId != null && activeTarget?.kind === "node" && activeTarget.nodeId === nodeId, ()=>false);
}
export function useIsContextMenuActiveEdge(source, target) {
    return useSyncExternalStore(subscribe, ()=>activeTarget?.kind === "edge" && activeTarget.source === source && activeTarget.target === target, ()=>false);
}

//# sourceMappingURL=activeTarget.js.map